import React from 'react';
import { motion } from 'framer-motion';
import styles from './index.module.css';
import touchPosImage from '../../assets/touchPosSet.png';
import {
  PiStarFill,
  PiUserFill,
  PiGauge,
  PiPenNib,
  PiMonitor,
  PiCloudCheck,
} from 'react-icons/pi';

const TRUST_AVATAR_COUNT = 4;

const FEATURES = [
  {
    icon: PiGauge,
    title: 'Fast & Reliable',
    description: 'Powerful performance for busy environments.',
  },
  {
    icon: PiPenNib,
    title: 'Sleek Design',
    description: 'Modern, durable and built to last.',
  },
  {
    icon: PiMonitor,
    title: 'Premium Hardware',
    description: 'High quality hardware for reliable performance.',
  },
  {
    icon: PiCloudCheck,
    title: 'Cloud Connected',
    description: 'Real-time sync across all your devices.',
  },
];

const TouchPos = () => {
  return (
    <div className={styles.mainDiv}>
      <div className={styles.innerDiv}>
        <div className={styles.leftDiv}>
          <div className={styles.heroContent}>
            <h2 className={styles.titleDiv}>
              Transform Your Business with Our New <span className={styles.titleAccent}> Dual-Touch POS</span>
             
            </h2>
            <p className={styles.descriptionDiv}>
              <strong>EPINICS</strong> brings together POS, payments,
              inventory, staff management and <strong>analytics</strong> in{' '}
              <strong>one powerful</strong> platform built to help you grow.
            </p>
            <a
              className={styles.salesLink}
              href="https://web.whatsapp.com/send?phone=94741041212&text=Hello%2C%20I%20have%20an%20inquiry%20regarding%20your%20POS%20system.%20Could%20you%20please%20assist%20me%3F"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.salesBtn}>Talk To Sales</div>
            </a>
            <div className={styles.trustBadge}>
              <div className={styles.avatarStack}>
                {[...Array(TRUST_AVATAR_COUNT)].map((_, i) => (
                  <div key={i} className={styles.avatar} aria-hidden="true">
                    <PiUserFill className={styles.avatarIcon} />
                  </div>
                ))}
              </div>
              <div className={styles.trustInfo}>
                <div className={styles.stars}>
                  {[...Array(5)].map((_, i) => (
                    <PiStarFill className={styles.star} key={i} />
                  ))}
                </div>
                <p className={styles.trustText}>Trusted by 100+ Businesses</p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.rightDiv}>
          <motion.div
            className={styles.imgWrapper}
            initial={{ opacity: 0, x: 80, scale: 0.94 }}
            whileInView={{ opacity: 1, x: 0, scale: 1 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            viewport={{ once: true, amount: 0.25 }}
          >
            <img
              className={styles.img}
              src={touchPosImage}
              alt="Epinics Point of Sale terminal"
              loading="lazy"
            />
          </motion.div>
        </div>
      </div>
      <div className={styles.featuresBar}>
        {FEATURES.map(({ icon: Icon, title, description }) => (
          <div className={styles.featureItem} key={title}>
            <Icon className={styles.featureIcon} aria-hidden="true" />
            <h3 className={styles.featureTitle}>{title}</h3>
            <p className={styles.featureDesc}>{description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TouchPos;
